var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScissor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8795 72.3109C37.0863 75.5673 38.5416 78.528 39.413 81.9508C40.0799 84.5705 41.191 89.8365 39.7508 92.2267C38.9551 93.5472 37.1186 94.2646 35.8945 94.902C33.8758 95.9533 32.0741 97.4348 29.9167 98.1628C26.6528 99.264 21.8125 95.8013 18.7754 94.1399C15.8832 92.5576 14.4448 88.1698 14.5803 84.6375C14.6615 82.5192 15.8099 79.4769 16.314 77.4468C16.7249 75.792 18.6165 74.3483 18.6709 72.7777C18.71 71.6477 19.3122 68.5688 20.3955 68.2691C22.2089 67.7673 22.4106 66.6308 23.3986 65.166C24.6523 63.3072 27.2051 63.7691 28.7645 62.6377C30.2471 61.5622 31.8336 61.2212 33.548 60.8646C36.2068 60.3116 38.9811 59.3363 41.2246 57.7117C43.9137 55.7644 47.0035 54.9722 49.7583 53.2277C52.1842 51.6915 54.0026 49.1354 56.917 48.7703C61.4212 48.2061 64.28 46.4855 68.299 44.5873C72.5262 42.5906 78.1999 43.3034 82.7865 43.2454C84.5032 43.2237 86.3092 43.8189 87.9555 43.2078C89.3583 42.687 90.658 42.2422 92.1285 41.9363",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3589 73.3586C35.7126 73.4009 34.713 70.359 34.2389 69.714C33.3187 68.462 31.9405 65.7841 30.6099 65.3618",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1333 51.2947C49.6878 52.7204 51.3531 52.8692 52.3707 53.6187C54.4114 55.1217 56.5372 55.4647 58.6234 56.726C63.0351 59.3933 67.7386 61.2554 72.1642 64.1357C74.9683 65.9607 78.2209 66.514 81.1376 68.0288C83.2131 69.1068 85.3359 70.1691 87.4966 70.9377C89.6686 71.7104 91.1108 72.1842 93.2217 71.7451",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4985 52.8457C51.1563 51.787 48.6739 51.9484 47.7939 51.5684C46.1419 50.855 44.7063 50.0082 43.1765 48.9735C39.7193 46.6349 35.4101 45.5363 31.6662 43.9441C26.9634 41.9441 22.4935 40.4219 18.027 37.5372C13.565 34.6554 7.25664 27.4773 7.38954 21.2337C7.4676 17.5661 9.51715 17.4209 11.8349 16.2702C13.5513 15.4181 14.9932 13.8274 16.9852 14.4595C18.955 15.0845 20.9631 15.6242 22.9189 16.2971C24.1671 16.7265 25.0176 18.3116 25.97 19.2746C29.7797 23.1268 31.829 28.4293 32.9647 33.8898C33.3718 35.8468 33.3809 37.4604 33.0062 39.2852C32.7488 40.5385 32.1421 40.5636 32.4334 41.9642",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissor);
export default __webpack_public_path__ + "static/media/scissor.5b6753890b6f3eec5db2ef0a8b70df70.svg";
export { ForwardRef as ReactComponent };